import React from 'react';
import { useReveal } from '../hooks/useReveal';
import { useLocale } from '../i18n/LocaleContext';

const ProcessSection = () => {
  const ref = useReveal();
  const { t } = useLocale();
  const steps = [
    { no: '01', title: t('home.process1Title'), body: t('home.process1Body'), accent: '#b1c1ef' },
    { no: '02', title: t('home.process2Title'), body: t('home.process2Body'), accent: '#f2acac' },
    { no: '03', title: t('home.process3Title'), body: t('home.process3Body'), accent: '#ffdd94' },
    { no: '04', title: t('home.process4Title'), body: t('home.process4Body'), accent: '#8ea78f' },
  ];

  return (
    <section
      ref={ref}
      className="bg-surface text-mainkleur py-20 sm:py-24 lg:py-32 border-t border-hairline"
    >
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14 sm:mb-20">
          <div className="flex flex-col gap-5">
            <span className="eyebrow text-muted">{t('home.processEyebrow')}</span>
            <h2 className="font-anton uppercase text-[14vw] sm:text-[88px] lg:text-[120px] leading-[0.9] tracking-[-3px] lg:tracking-[-6px]">
              {t('home.processTitle')}
            </h2>
          </div>
          <p className="font-space text-muted text-[15px] sm:text-[17px] lg:text-[20px] leading-[1.5] max-w-[460px] lg:text-right">
            {t('home.processIntro')}
          </p>
        </div>

        <div className="h-px w-full bg-hairline mb-2" />

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-px bg-hairline border border-hairline">
          {steps.map((step) => (
            <article
              key={step.no}
              className="reveal-up group relative bg-surface p-7 sm:p-8 lg:p-9 flex flex-col gap-5 min-h-[280px] sm:min-h-[300px] overflow-hidden"
            >
              <div
                aria-hidden="true"
                className="pointer-events-none absolute -top-16 -right-12 w-44 h-44 rounded-full blur-[70px] opacity-25 group-hover:opacity-50 transition-opacity duration-500"
                style={{ backgroundColor: step.accent }}
              />
              <span
                className="section-number text-[64px] sm:text-[76px] lg:text-[84px]"
                style={{ color: step.accent }}
              >
                {step.no}
              </span>
              <h3 className="font-bricolage font-extrabold text-mainkleur text-[24px] sm:text-[28px] tracking-tight">
                {step.title}
              </h3>
              <p className="font-space text-muted text-[14px] sm:text-[15px] leading-[1.55]">
                {step.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
